export default "__VITE_ASSET__CSZEmuUJ__"